module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-800.615422db.svg";